import Vue from 'vue'
import Router from 'vue-router'
import cookie from 'js-cookie'
import { WeiXinRegister } from '@/utils/weixin'
import { isWXEnv } from '@/utils/env'
import { currentTenant } from '@/constants'
import store from '@/store'
import jurorRoutes from './permissionRoutes/jurorRoutes'
import judgeRoutes from './permissionRoutes/judgeRoutes'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '@/views/login/Login.vue')
  }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [...routes]
})

const router = createRouter()

// 不需要登录的路由名单列表
const whiteRoutes = ['/login']

router.beforeEach(async (to, from, next) => {
  const isLogined = cookie.get('TOKEN')
  if (whiteRoutes.includes(to.path)) {
    next()
  } else {
    if (isLogined) {
      if (!store.state.isAddedRoutes) {
        const { userInfo } = JSON.parse(await window.sessionStorage.getItem(currentTenant) || '{}')
        if (userInfo) {
          addRoutes(userInfo.role)
          next({ ...to, replace: true })
        } else {
          const roles = await store.dispatch('getRoles')
          if ([].concat(roles).includes('JUROR')) {
            addRoutes('juror')
            next({ ...to, replace: true })
          } else {
            addRoutes('judge')
            next({ ...to, replace: true })
          }
        }
      } else {
        next()
      }
    } else {
      next('/login')
    }
  }
})

router.afterEach((to) => {
  // 注册微信
  if (isWXEnv() && to.meta.register === 'wx') {
    WeiXinRegister()
  }
})

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

/**
 * 根据角色添加路由
 * @string {*} role 角色
 */
export function addRoutes (role) {
  if (role === 'juror') {
    console.log('add')
    store.commit('UPDATE_IS_ADDED_ROUTES', true)
    router.addRoutes(jurorRoutes)
  } else if (role === 'judge') {
    router.addRoutes(judgeRoutes)
    store.commit('UPDATE_IS_ADDED_ROUTES', true)
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js